// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"f2a7299418fea3d512d0","678":"d414c60dd62700648ab1"}[chunkId] + ".js";
};